/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (control effect) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		edges_strength: {
			label: 'Edges',
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			unit: '%',
			kind: 'range',
			icon: 'mo/frame_person',
			tooltip: {
				heading: 'Edges',
				body: 'How much the AI should focus on the lines and edges in the image.',
			},
		},
		depth_strength: {
			label: 'Depth',
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			unit: '%',
			kind: 'range',
			icon: 'mo/deployed_code',
			tooltip: {
				heading: 'Depth',
				body: 'How much the AI should focus on the 3D depth in the image.',
			},
		},
		depth_floor: {
			type: 'integer',
			minimum: 0,
			maximum: 50,
			step: 1,
			initial: 0,
			label: 'Depth Floor',
			kind: 'range',
		},
		pose_strength: {
			label: 'Pose',
			type: 'number',
			minimum: 0,
			maximum: 100,
			step: 1,
			initial: 0,
			unit: '%',
			kind: 'range',
			icon: 'mo/accessibility_new',
			tooltip: {
				heading: 'Pose',
				body: 'How much the AI should follow the body pose of people in the image.',
			},
		},
		pose_floor: {
			type: 'integer',
			minimum: 0,
			maximum: 70,
			step: 1,
			initial: 50,
			label: 'Pose Floor',
			kind: 'range',
		},
	},
	label: 'Control',
	primary: ['edges_strength', 'depth_strength', 'pose_strength'],
}
